import axios, { CancelTokenSource } from "axios";
import api, { ApiResponse } from "./../api";
import { ImageHistoryLogsFilterModel, ImageHistoryLogsItemModel, ImageHistoryTableInfoModel } from "./imageHistoryLogsModels";
export const REQUEST_ID: {
    [key: string]: string;
} = {
    GET_RECORDS: "get_image_history_logs"
};

class ImageHistoryLogsService {
    private source: {
        [key: string]: CancelTokenSource;
    };

    private static instance: ImageHistoryLogsService;

    private constructor() {
        this.source = {};
    };

    static getInstance(): ImageHistoryLogsService {
        if (!ImageHistoryLogsService.instance) {
            ImageHistoryLogsService.instance = new ImageHistoryLogsService();
        }
        return ImageHistoryLogsService.instance;
    };

    public getImageHistoryLogsRecords = async (
        filter: ImageHistoryLogsFilterModel,
        page: number
    ): Promise<ApiResponse<ImageHistoryLogsItemModel>> => {
        this.source[REQUEST_ID.GET_RECORDS] && this.source[REQUEST_ID.GET_RECORDS].cancel();
        this.source[REQUEST_ID.GET_RECORDS] = axios.CancelToken.source();
        return await api.post(
            "image-history-logs/imagehistory",
            { ...filter, page }, // Send the payload in the request body
            {
                cancelToken: this.source[REQUEST_ID.GET_RECORDS].token,
            }
        );
    };

    public getImageHistoryTableInfo = async (): Promise<ApiResponse<ImageHistoryTableInfoModel>> => {
        return await api.get("dotnet-programs-logs/tableinfo?type=image");
    };
};

export default ImageHistoryLogsService;
